import type { FaireProductEntity } from "../../entity_types/product";

export const p_pxvxayp85k: FaireProductEntity = {
  token: "p_pxvxayp85k",
  type: "product",
  name: "Flatiron - 12oz - Whole Bean Coffee",
  brandToken: "b_4db0zb0iws",
  brandName: "Partners Coffee Roasters",
  imageUrl:
    "https://cdn.faire.com/fastly/4ce2ee53c40e06221e454581be85607777915bb7e16c07a96d39432394942f35.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f62c3f84d6212236d84bbf517574fadb94cc95c99c9ab86c8187baaa13d68d9f.jpeg",
    "https://cdn.faire.com/fastly/5628a3815d39929fc08f6a59e7ddab55e5074571d000f6998ad321c3c0706d23.jpeg",
    "https://cdn.faire.com/fastly/dc538b2132021596f056f2f41f9f17875d72625dfa949297d6c8627e87cf92c7.jpeg",
    "https://cdn.faire.com/fastly/0214668a4fe07aac6426b0c3d7b95dfc8d8df251f3fc76aafc94fd946467423d.jpeg",
  ],
  priceDollars: 10.92,
  description:
    "We created this blend specially for our New York customers and liked it so much we now serve it at our Vanderbilt and Long Island City stores. Sweet, velvety and rich with chocolate, this balanced espresso shines in milk-based drinks.\n\n𝐂𝐨𝐟𝐟𝐞𝐞 𝐈𝐧𝐟𝐨\n• Sources Carmo Coffees and ASOBOMBO\n• Tasting Notes Dark Chocolate, Praline and Dates\n• Elevation 1,100 - 1,900 meters\n• Region Minas Gerais and Antioquia\n• Process Dry and Wet-Processed\n\n𝐅𝐚𝐫𝐦 𝐑𝐞𝐥𝐚𝐭𝐢𝐨𝐧𝐬𝐡𝐢𝐩\n• Yes\n\nPerfect For: Father's Day gifting",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:13.408Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
